import React from "react";
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Collapse
} from "reactstrap";
import PropTypes from "prop-types";
export default class LessonCard extends React.Component {
  state = {
    collapse: true
  };

  render() {
    const {
      iconClass,
      heading,
      subHeading,
      isCollapsable,
      headerButtons,
      footerButtons
    } = this.props;
    return (
      <Card className="edit-lesson">
        <CardHeader className="card-header">
          <div className='top-row'>
            <i className={`icon-${iconClass}`} />
            <div className='header-text'>{heading}</div>
            <div className="right-buttons">
              {headerButtons &&
                headerButtons.map((value, index) => (
                  <span key={index} className="rt-btn">
                    {value}
                  </span>
                ))}
              {isCollapsable && (
                <i
                  className={`card-collapse-${
                    this.state.collapse ? "true" : "false"
                    }`}
                  onClick={() =>
                    this.setState({ collapse: !this.state.collapse })
                  }
                />
              )}
            </div>
          </div>
          <div className='sub-heading'>{subHeading}</div>
        </CardHeader>
        {(isCollapsable) ? (
          <Collapse isOpen={this.state.collapse}>
            <CardBody>{this.props.children}</CardBody>
          </Collapse>
        ) : (
            <CardBody>{this.props.children}</CardBody>
          )}

        {footerButtons && (
          <CardFooter className="card-footer">
            <div className="right-buttons">
              {footerButtons.map((value, index) => (
                <span key={index} className="rt-btn">
                  {value}
                </span>
              ))}
            </div>
          </CardFooter>
        )}
      </Card>
    );
  }
}
LessonCard.propTypes = {
  iconClass: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  subHeading: PropTypes.string,
  isCollapsable: PropTypes.bool.isRequired,
  headerButtons: PropTypes.array,
  footerButtons: PropTypes.array
};



// WEBPACK FOOTER //
// ./src/components/Users/Authors/LessonCard.js